import dtp from 'bootstrap-datetimepicker-npm';
dtp($);
// Get server-side data stored as JSON
let modelData = JSON.parse(document.getElementById('page-data').textContent);
$(document).ready(function () {
    $("select").val(""); //force all selects to reset to empty selections.
    $(".bsdatepicker").datetimepicker({
        //pickTime: false,
        minDate: new moment(modelData.fStartIsoString),
        maxDate: new moment(modelData.fEndIsoString),
        showClose: true,
        collapse: false,
        useStrict: true,
        useCurrent: modelData.IsNow,
        locale: 'en',
        sideBySide: true,
        //debug: true
    });
});
